
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IOrgData } from '@/types/media-types'

@Component({
    name: 'OrgTable',
    components: {
    }
})
export default class extends Vue {
    @Prop({ required: true }) private orgList!: IOrgData[]

    private onDetail(data: any) {
        this.$router.push({ name: 'MediaOrgDetail', params: { id: data.id } })
    }

    private onEdit(data: any) {
        window.open('/media/org/' + data.id + '/edit')
    }
}
